n
<template>
  <div class="view contentBody">
    <div class="content ">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
      <!--<el-tab-pane label="任务设置" name="AnalyticsOpportunitySetting">-->
      <!--<AnalyticsOpportunitySetting></AnalyticsOpportunitySetting>-->
      <!--</el-tab-pane>-->
    </div>
  </div>
</template>
<script>
  import AnalyticsOpportunityBusiness from "./AnalyticsOpportunityBusiness.vue";
  import AnalyticsOpportunitySetting from "./AnalyticsOpportunitySetting.vue";
  let tabBox = {
    '商机设置': {property: 'AnalyticsOpportunityBusiness'}
  }

  export default {
    name: "opportunity",
    components: {
      AnalyticsOpportunityBusiness,
      AnalyticsOpportunitySetting
    },
    data() {
      return {
        meaulistTab: this.meaulist.meaulistGet(this, tabBox),
        activeName:''
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "AnalyticsOpportunityBusiness";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
